export const FaTableIcon = (props) => (
  <svg aria-hidden="true" fill="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M448 96l0 64L224 160l0-64 224 0zM64 96l96 0 0 64-96 0 0-64zM0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zM160 224l0 192-96 0 0-192 96 0zm64 0l224 0 0 192-224 0 0-192z" />
  </svg>
);
